<ng-container *ngIf="(teamMvpUsers && teamMvpUsers.length > 0) || (competitorTeamMvpUsers && competitorTeamMvpUsers.length > 0)">
  <div class="title">Лучшие игроки</div>

  <div class="mvp-users">
    <div class="team" *ngIf="teamMvpUsers">
      <ng-container *ngFor="let user of teamMvpUsers">
        <div class="user">
          <div class="info">
            <div class="fullname">{{ user.tournamentTeamUser.leaguePlayer.fullName }}</div>
            <div class="position">{{ user.teamUser.user.footballProfile.position | localization: positionLocalization }}</div>
          </div>
          <div class="photo">
            <img [src]="user.tournamentTeamUser.leaguePlayer.photo.path" *ngIf="user.tournamentTeamUser.leaguePlayer.photo.path">
            <div class="empty-photo" *ngIf="!user.tournamentTeamUser.leaguePlayer.photo.path">{{ user.tournamentTeamUser.leaguePlayer.initials }}</div>
          </div>
        </div>
        <div class="statistic" *ngIf="userStatistic[user.id]">
          <div class="item" *ngFor="let item of getUserStatistic(user)">
            <div class="value">{{ item.value || 0 }}</div>
            <div class="name">{{ item.title}}</div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="team right" *ngIf="competitorTeamMvpUsers">
      <ng-container *ngFor="let user of competitorTeamMvpUsers">
        <div class="user">
          <div class="info">
            <div class="fullname">{{ user.tournamentTeamUser.leaguePlayer.fullName }}</div>
            <div class="position">{{ user.teamUser.user.footballProfile.position | localization: positionLocalization }}</div>
          </div>
          <div class="photo">
            <img [src]="user.tournamentTeamUser.leaguePlayer.photo.path" *ngIf="user.tournamentTeamUser.leaguePlayer.photo.path">
            <div class="empty-photo" *ngIf="!user.tournamentTeamUser.leaguePlayer.photo.path">{{ user.tournamentTeamUser.leaguePlayer.initials }}</div>
          </div>
        </div>
        <div class="statistic" *ngIf="userStatistic[user.id]">
          <div class="item" *ngFor="let item of getUserStatistic(user)">
            <div class="value">{{ item.value || 0 }}</div>
            <div class="name">{{ item.title}}</div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
